<div class="col-md-12">
    <div class="mb-3 mt-2 d-flex justify-content-between align-items-center">
        <h5 class="mb-0">Payment Details</h5>
        <button class="btn btn-secondary" (click)="goBack()">
            <i class="fa fa-arrow-left"></i> Back to List
        </button>
    </div>
    <div *ngIf="loading; else contentLoaded" style="text-align: center; padding: 40px 0;">
        Loading payment details...
    </div>
    <ng-template #contentLoaded>
        <div *ngIf="payment; else notFound">
            <div class="card mb-4">
                <div class="card-header">
                    <strong>Payment Information</strong>
                </div>
                <div class="card-body">
                    <div class="row">
                        <div class="col-md-6">
                            <p><strong>Transaction Ref:</strong> {{ payment.transactionRef }}</p>
                            <p><strong>Payment Type:</strong> {{ payment.paymentType }}</p>
                            <p><strong>Status:</strong>
                                <span class="badge ms-2" [ngClass]="{
                                    'bg-success': payment.status === 'SUCCESS',
                                    'bg-primary': payment.status === 'CONFIRMED',
                                    'bg-danger': payment.status === 'FAILED',
                                    'bg-secondary': payment.status === 'REJECTED',
                                    'bg-brown': payment.status === 'REFUNDED',
                                    'bg-warning': payment.status === 'PENDING',
                                    'bg-dark': payment.status === 'CANCELLED'
                                }">
                                    {{ payment.status }}
                                </span>
                            </p>
                            <p><strong>Payment Method:</strong> {{ payment.paymentMethod }}</p>
                        </div>
                        <div class="col-md-6">
                            <p><strong>Amount:</strong> {{ payment.amount }} {{ payment.currency | uppercase }}</p>
                            <p><strong>Phone Number:</strong> {{ payment.phoneNumber }}</p>
                            <p><strong>Payment Date:</strong> {{ payment.paymentDate | date: 'medium' }}</p>
                        </div>
                    </div>
                </div>
            </div>

            <div class="card mb-4">
                <div class="card-header">
                    <strong>User Information</strong>
                </div>
                <div class="card-body">
                    <div class="row">
                        <div class="col-md-6">
                            <p><strong>Name:</strong> {{ payment.user.firstName + ' ' + payment.user.lastName }}</p>
                            <p><strong>Email:</strong> {{ payment.user.email }}</p>
                        </div>
                        <div class="col-md-6">
                            <p><strong>Phone:</strong> {{ payment.user.phone }}</p>
                        </div>
                    </div>
                </div>
            </div>

            <div class="card mb-4" *ngIf="payment.paymentMethod === 'COMPANY_MOBILE_MONEY' && payment.status === 'CONFIRMED'">
                <div class="card-header">
                    <strong>Update Status</strong>
                </div>
                <div class="card-body">
                    <div class="d-flex gap-2">
                        <button class="btn btn-success" (click)="changeStatus('SUCCESS')" [disabled]="updating">
                            <span *ngIf="updating">Updating...</span>
                            <span *ngIf="!updating">Mark as SUCCESS</span>
                        </button>
                        <button class="btn btn-danger" (click)="changeStatus('REJECTED')" [disabled]="updating">
                            <span *ngIf="updating">Updating...</span>
                            <span *ngIf="!updating">Mark as REJECTED</span>
                        </button>
                    </div>
                </div>
            </div>

        </div>
        <ng-template #notFound>
            <div class="alert alert-warning" role="alert">
                Payment not found.
            </div>
            <button class="btn btn-secondary" (click)="goBack()">Back to List</button>
        </ng-template>
    </ng-template>
</div>
